import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
/**
 * Card component - a container with semantic styling
 */
export const Card = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
    return _jsx("div", { ref: ref, className: clsx('card', `card--${variant}`, className), ...props });
});
Card.displayName = 'Card';
export const CardHeader = React.forwardRef(({ className, ...props }, ref) => {
    return _jsx("div", { ref: ref, className: clsx('card-header', className), ...props });
});
CardHeader.displayName = 'CardHeader';
export const CardTitle = React.forwardRef(({ className, ...props }, ref) => {
    return _jsx("h3", { ref: ref, className: clsx('card-title', className), ...props });
});
CardTitle.displayName = 'CardTitle';
export const CardContent = React.forwardRef(({ className, ...props }, ref) => {
    return _jsx("div", { ref: ref, className: clsx(className), ...props });
});
CardContent.displayName = 'CardContent';
//# sourceMappingURL=Card.js.map